import { render } from "./TermsContent.vue?vue&type=template&id=77aa0a17"
import script from "./TermsContent.vue?vue&type=script&lang=js"
export * from "./TermsContent.vue?vue&type=script&lang=js"

import "./TermsContent.vue?vue&type=style&index=0&id=77aa0a17&lang=css"

import exportComponent from "/Users/sung-hojang/git-projects/jpworldpay-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__